interface Props {
  color?: string;
  width?: string;
  height?: string;
}

function AlertWarning(props: Props) {
  const { color = "#0f9470", width = "20", height = "20" } = props;

  return (
    <svg width="16" height="16" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_16204_12877)">
        <path
          d="M3.43652 5.84524H4.43652L6.88652 1.90524C6.98639 1.7461 7.12502 1.61491 7.28943 1.52396C7.45384 1.43301 7.63864 1.38528 7.82652 1.38525C8.11919 1.38523 8.40002 1.50081 8.6079 1.70681C8.81578 1.91282 8.93389 2.19259 8.93652 2.48524V5.34524H12.7865C12.9526 5.34631 13.1165 5.38303 13.2672 5.45291C13.4178 5.52279 13.5517 5.62421 13.6598 5.7503C13.7679 5.8764 13.8476 6.02423 13.8936 6.1838C13.9397 6.34337 13.9509 6.51096 13.9265 6.67524L13.1265 11.6152C13.0924 11.891 12.9587 12.1448 12.7507 12.3289C12.5426 12.5131 12.2744 12.6149 11.9965 12.6152H2.93652"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M1.06152 5.84521V12.6152" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_16204_12877">
          <rect width="14" height="14" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default AlertWarning;
